import { render, staticRenderFns } from "./practiceLib.vue?vue&type=template&id=f2bf9e88&"
import script from "./practiceLib.js?vue&type=script&lang=js&"
export * from "./practiceLib.js?vue&type=script&lang=js&"
import style0 from "./practiceLib.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports